import React from 'react'
import classNames from 'classnames'

import { LntSpin } from '@app/components/base'

import styles from './styles.module.scss'

import type { LoaderProps } from './types'

export const Loader: React.FC<LoaderProps> = props => {
  const { fullScreen, ...spinProps } = props

  const className = classNames(styles.loader, { [styles.loader_fullScreen]: fullScreen })

  return (
    <div className={ className }>
      <LntSpin { ...spinProps } />
    </div>
  )
}
